import { StickerContainer } from 'dashboard/components/WorkflowStatusSticker/WorkflowStatusSticker';
import Sticker from 'design-system/components/Sticker';

interface HttpStatusStickerProps {
  status: number;
}

const GetVariant = (status: number) => {
  if (status >= 200 && status < 300) {
    return 'green';
  } else if (status >= 300 && status < 400) {
    return 'blue';
  } else if (status === 404) {
    return 'basic';
  } else if (status >= 400 && status < 500) {
    return 'yellow';
  } else {
    return 'red';
  }
};
const HttpStatusSticker = ({ status }: HttpStatusStickerProps) => {
  const variant = GetVariant(status);
  return (
    <StickerContainer>
      <Sticker variant={variant}>{status}</Sticker>
    </StickerContainer>
  );
};

export default HttpStatusSticker;
